import React from 'react'
import { useSelector } from 'react-redux'
import TodoItem from './TodoItem'
import "./TodoItem.css"

function TodoList() {
    let todos=useSelector(state=>state)

    return (
        <div className="todoList">
          {todos.map(todo=>{
              return <TodoItem key={todo.id} todo={todo}/>
          })}
            
        </div>
    )
}

export default TodoList
